export const ThemeConstants = {

    GET_THEME_INFO_LOADING: 'GET_THEME_INFO_LOADING',
    GET_THEME_INFO: 'GET_THEME_INFO',
    GET_THEME_INFO_ERROR: 'GET_THEME_INFO_ERROR',

};
